import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Button,
  Image,
  Text,
  Icon,
  Badge,
  Divider,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  FaDownload,
  FaSync,
  FaPrint,
  FaPlus,
  FaClock,
  FaBook,
  FaSchool,
  FaHome,
  FaUsers,
  FaRegClock,
} from "react-icons/fa";

import TransferCertificate from "./Transfer";
import ConductCertificate from "./Conduct";
import ClassTest from "../../ReportCard/ClassTest/ClassTest";
import ModelTest from "../../ReportCard/ModelTest/ModelTest";
import AnnualReport from "../../ReportCard/AnnualReport/AnnualReport";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import PrintPdf from "./Print_Pdf";
import axios from "axios";
import Print_Pdf from "./Print_Pdf";
import Student_Profile_Individual from "../../Bus/BusProfileStudentIndividual/Student_Profile_Individual";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const StudentDetails = () => {
  const navigate = useNavigate();
  const [showPrintPdf, setShowPrintPdf] = useState(false);
  const [error, setError] = useState("");

  const { user_id } = useParams(); // Retrieve user_id from URL parameters
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedIndex, setExpandedIndex] = useState(-1); // Track the index of the expanded accordion item
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component

  useEffect(() => {
    const fetchStudentDetails = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/student/view_student.php?user_id=${user_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        console.log("studentttttt", data);

        if (data.success) {
          setStudentData(data.data);
          setIsDataLoaded(true); // Mark data as loaded
        } else {
          console.error("Error:", data.message);
        }
      } catch (error) {
        console.error("Error fetching student details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudentDetails();
  }, [user_id]);

  if (loading) {
    return (
      <Box p={4} textAlign="center" fontSize="lg">
        Loading...
      </Box>
    );
  }

  if (!studentData) {
    return (
      <Box p={4} textAlign="center" fontSize="lg">
        No student data found.
      </Box>
    );
  }

  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  return (
    <div className="teacher-list-container">
      <div
        className="header"
        style={{ display: "flex", alignItems: "center", padding: "10px 0" }}
      >
        <h1
          style={{
            fontSize: "22px",
            margin: 0,
            color: "#3d3d3d",
            fontWeight: "600",
          }}
        >
          Student Profile
        </h1>
        <div className="action-buttons" style={{ marginLeft: "auto" }}>
          <Button
            className="export-button"
            display={{ base: "none", md: "flex" }}
            backgroundColor="white"
            fontSize="12px"
            boxShadow="sm"
            color="teal.600"
            onClick={handlePrint} // Attach the print handler here
            borderRadius="lg"
            _hover={{ bg: "teal.50" }}
          >
            <FaPrint color="#515B73" />
            Print PDF
          </Button>
        </div>
      </div>

      <Box className="breadcrumb" fontSize="sm" color="gray.600" mb={4}>
        <Link to="/admin" style={{ textDecoration: "none", color: "inherit" }}>
          Dashboard
        </Link>
        {" / "}
        <Link
          to="/students/all"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          All Students
        </Link>{" "}
        / <span>Student Profile</span>
      </Box>

      <Box p={4} mt={4}>
        <Grid templateColumns={{ base: "1fr", md: "1fr 3fr" }} gap={6}>
          <GridItem>
            {/* Profile box */}
            <Box
              p={6}
              borderRadius="xl"
              bg="white"
              boxShadow="lg"
              _hover={{ boxShadow: "2xl" }}
              transition="all 0.3s ease"
              maxW="100%"
              overflow="hidden"
              minW={{ base: "none", md: "400px" }}
              borderWidth="1px"
              borderColor="teal.100"
            >
              <Flex
                alignItems="center"
                mb={4}
                direction={{ base: "column", md: "row" }}
                bgGradient="linear(to-r, teal.400, cyan.400)"
                borderRadius="xl"
                p={6}
                color="white"
                position="relative"
                overflow="hidden"
                _before={{
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  bgGradient:
                    "linear(to-r, rgba(255,255,255,0.1), rgba(255,255,255,0))",
                  transform: "skewX(-15deg)",
                }}
              >
                <Image
                  src={
                    studentData.image_url ||
                    "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"
                  }
                  alt="Student"
                  borderRadius="full"
                  boxSize={{ base: "100px", md: "120px" }}
                  objectFit="cover"
                  onError={(e) => {
                    e.target.src =
                      "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                  }}
                  border="4px solid white"
                  boxShadow="lg"
                  mb={{ base: 4, md: 0 }}
                />
                <Box ml={{ md: 3 }} textAlign={{ base: "center", md: "left" }}>
                  <Text
                    fontWeight="bold"
                    fontSize={{ base: "lg", md: "lg" }}
                    color="white"
                    letterSpacing="wide"
                  >
                    {studentData.name}
                  </Text>
                  <Text fontSize="md" color="teal.50" mb={2}>
                    {studentData.username}
                    
                  </Text>

                  <Badge
                    px={2}
                    py={1}
                    bg="white"
                    color="teal.500"
                    rounded="full"
                    fontSize="sm"
                    fontWeight="semibold"
                  >
                    {studentData.utype === "1" && "Admin"}
                    {studentData.utype === "2" && "Staff"}
                    {studentData.utype === "3" && "Student"}
                  </Badge>
                </Box>
              </Flex>

              <Box
                mt={6}
                p={4}
                bg="teal.50"
                borderRadius="lg"
                border="1px dashed teal.200"
              >
                <Flex wrap="wrap" gap={6} justify="space-between">
                  {[
                    { label: "Aadhar No", value: studentData.aadhar_no },
                    { label: "Gender", value: studentData.gender },
                    { label: "Email", value: studentData.email },
                    { label: "DOB", value: studentData.date_of_birth },
                    { label: "Blood Group", value: studentData.group },
                    { label: "Medium", value: studentData.caption },
                  ].map((item) => (
                    <Box key={item.label} minW="150px">
                      <Text
                        color="teal.700"
                        fontSize="sm"
                        fontWeight="semibold"
                        mb={1}
                      >
                        {item.label}
                      </Text>
                      <Text color="gray.700" fontSize="sm">
                        {item.value}
                      </Text>
                    </Box>
                  ))}
                </Flex>
              </Box>
            </Box>

            <Box mt={3}>
              <Student_Profile_Individual studentId={studentData.id} />
            </Box>
          </GridItem>

          <GridItem>
            {/* Parents Box */}
            <Box
              p={6}
              borderRadius="xl"
              bg="white"
              boxShadow="lg"
              _hover={{ boxShadow: "2xl" }}
              transition="all 0.3s ease"
              mb={6}
              borderWidth="1px"
              borderColor="blue.100"
              position="relative"
              overflow="hidden"
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                h="6px"
                bgGradient="linear(to-r, blue.300, cyan.300)"
              />
              <Flex align="center" mb={4}>
                <Box
                  bg="blue.100"
                  p={2}
                  borderRadius="lg"
                  color="blue.500"
                  mr={3}
                >
                  <Icon as={FaUsers} boxSize={5} />
                </Box>
                <Text fontWeight="bold" fontSize="xl" color="blue.700">
                  Parent Information
                </Text>
              </Flex>
              <Grid
                templateColumns="repeat(auto-fit, minmax(250px, 1fr))"
                gap={6}
                bg="blue.50"
                p={4}
                borderRadius="lg"
              >
                {[
                  { label: "Father's Name", value: studentData.father_name },
                  { label: "Mother's Name", value: studentData.mother_name },
                  {
                    label: "Guardian's Name",
                    value: studentData.guardian_name,
                  },
                ].map((item) => (
                  <Box key={item.label}>
                    <Text
                      color="blue.600"
                      fontSize="sm"
                      fontWeight="semibold"
                      mb={1}
                    >
                      {item.label}
                    </Text>
                    <Text color="gray.700" fontSize="sm">
                      {item.value}
                    </Text>
                  </Box>
                ))}
              </Grid>
            </Box>
            {/* Address Box */}
            <Box
              p={6}
              borderRadius="xl"
              bg="white"
              boxShadow="lg"
              _hover={{ boxShadow: "2xl" }}
              transition="all 0.3s ease"
              mb={6}
              position="relative"
              overflow="hidden"
              borderWidth="1px"
              borderColor="purple.100"
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                h="6px"
                bgGradient="linear(to-r, purple.300, pink.300)"
              />
              <Flex align="center" mb={4}>
                <Box
                  bg="purple.100"
                  p={2}
                  borderRadius="lg"
                  color="purple.500"
                  mr={3}
                >
                  <Icon as={FaHome} boxSize={5} />
                </Box>
                <Text fontWeight="bold" fontSize="xl" color="purple.700">
                  Address
                </Text>
              </Flex>
              <Box
                p={4}
                bg="purple.50"
                borderRadius="lg"
                color="gray.700"
                fontSize="sm"
                lineHeight="tall"
              >
                {studentData.address}
              </Box>
            </Box>

            <TransferCertificate user_id={user_id} />

            <Box
              mt={3}
              borderRadius="xl"
              overflow="hidden"
              boxShadow="lg"
              border="1px solid"
              borderColor="teal.100"
            >
              <Accordion allowToggle>
                {/* Class Test Accordion Item */}
                <AccordionItem
                  border="none"
                  mb={2}
                  bg="white"
                  _hover={{ bg: "teal.50" }}
                  transition="all 0.3s ease"
                >
                  <AccordionButton
                    p={4}
                    _hover={{ bg: "transparent" }}
                    borderLeft="4px solid"
                    borderLeftColor="teal.400"
                    transition="all 0.3s ease"
                  >
                    <Flex align="center" flex="1">
                      <Box
                        bg="teal.100"
                        p={2}
                        borderRadius="lg"
                        color="teal.600"
                        mr={3}
                      >
                        <Icon as={FaBook} boxSize={5} />
                      </Box>
                      <Box>
                        <Text
                          fontSize="lg"
                          fontWeight="semibold"
                          color="teal.700"
                          _groupHover={{ color: "teal.800" }}
                        >
                          Class Test
                        </Text>
                        <Text fontSize="sm" color="teal.600" mt={1}>
                          View your class test performance and scores
                        </Text>
                      </Box>
                    </Flex>
                    <Box
                      bg="teal.50"
                      p={2}
                      borderRadius="full"
                      transition="transform 0.2s"
                      _expanded={{ transform: "rotate(180deg)" }}
                    >
                      <AccordionIcon color="teal.500" boxSize={5} />
                    </Box>
                  </AccordionButton>
                  <AccordionPanel
                    pb={6}
                    pt={4}
                    px={6}
                    bg="gradient.to.r"
                    from="teal.50"
                    to="cyan.50"
                  >
                    <ClassTest />
                  </AccordionPanel>
                </AccordionItem>

                {/* Annual Report Accordion Item */}
                <AccordionItem
                  border="none"
                  bg="white"
                  _hover={{ bg: "purple.50" }}
                  transition="all 0.3s ease"
                >
                  <AccordionButton
                    p={4}
                    _hover={{ bg: "transparent" }}
                    borderLeft="4px solid"
                    borderLeftColor="purple.400"
                    transition="all 0.3s ease"
                  >
                    <Flex align="center" flex="1">
                      <Box
                        bg="purple.100"
                        p={2}
                        borderRadius="lg"
                        color="purple.600"
                        mr={3}
                      >
                        <Icon as={FaRegClock} boxSize={5} />
                      </Box>
                      <Box>
                        <Text
                          fontSize="lg"
                          fontWeight="semibold"
                          color="purple.700"
                          _groupHover={{ color: "purple.800" }}
                        >
                          Annual Report
                        </Text>
                        <Text fontSize="sm" color="purple.600" mt={1}>
                          Access your complete annual academic performance
                        </Text>
                      </Box>
                    </Flex>
                    <Box
                      bg="purple.50"
                      p={2}
                      borderRadius="full"
                      transition="transform 0.2s"
                      _expanded={{ transform: "rotate(180deg)" }}
                    >
                      <AccordionIcon color="purple.500" boxSize={5} />
                    </Box>
                  </AccordionButton>
                  <AccordionPanel
                    pb={6}
                    pt={4}
                    px={6}
                    bg="gradient.to.r"
                    from="purple.50"
                    to="pink.50"
                  >
                    <ModelTest />
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Box>

            {/* Optional: Add a decorative background pattern */}
            <Box
              position="absolute"
              top={0}
              right={0}
              width="300px"
              height="300px"
              opacity={0.1}
              bgGradient="radial(circle at top right, teal.200, transparent 70%)"
              pointerEvents="none"
              zIndex={0}
            />
          </GridItem>
        </Grid>
      </Box>

      {/* Include Print_pdf_class_list but keep it hidden on the UI */}
      <div style={{ display: "none" }}>
        <Print_Pdf ref={printComponentRef} studentData={studentData} />
      </div>
    </div>
  );
};

export default StudentDetails;
